import { UserData } from './user-data-model';

export class Register {
  constructor(
    readonly Email: string,
    readonly Password: string,
    readonly Newsletter: boolean,
    readonly Country: string,
    readonly Language: string,
    readonly CustomerType: string,
    readonly Token: string | null
  ) {}
  static new(): Register {
    return new Register('', '', false, '', '', '', '');
  }
}
